const defaultCurrencyDefinition = {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}

const defaultCurrencyDefinitionRound = {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
}

const noFractionPercent = {
  style: 'percent',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
}

const twoFractionPercent = {
  style: 'percent',
  maximumFractionDigits: 2,
}

const noFraction = {
  style: 'decimal',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
}

const oneFraction = {
  style: 'decimal',
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
}

const twoFractions = {
  style: 'decimal',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}

const defaultFormats = {
  noFractionPercent,
  noFraction,
  oneFraction,
  twoFractions,
  twoFractionPercent,
  currency: defaultCurrencyDefinition,
  currencyRound: defaultCurrencyDefinitionRound,
}

export const getNumberFormats = (languages = []) => {
  return languages.reduce((acc, lang) => {
    acc[lang] = defaultFormats
    return acc
  }, {})
}
